import React, { useEffect, useRef } from "react";
import { s3ThemeAssetUrl } from "../../utils/themeAssets";

export default function TalentMediaPreviewModal({ item, onClose, titleColor }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!item) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
      videoRef.current?.pause();
    };
  }, [item, onClose]);

  if (!item) return null;

  const mediaUrl = s3ThemeAssetUrl(item.uploadFile);
  const isVideo = item.mediaType === "video";

  const handleClose = () => {
    videoRef.current?.pause();
    onClose();
  };

  return (
    <div className="yg-preview-backdrop" onClick={handleClose} role="presentation">
      <div
        className="yg-preview-modal"
        role="dialog"
        aria-label={item.name || "Media preview"}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="yg-preview-close" onClick={handleClose} aria-label="Close">
          ×
        </button>

        {item.name ? (
          <p className="yg-preview-name" style={{ color: titleColor }}>
            {item.name}
          </p>
        ) : null}

        {isVideo ? (
          <video
            ref={videoRef}
            key={mediaUrl}
            src={mediaUrl}
            className="yg-preview-media"
            controls
            autoPlay
            playsInline
          />
        ) : (
          <img
            src={mediaUrl}
            alt={item.name || "Talent upload"}
            className="yg-preview-media"
          />
        )}
      </div>
    </div>
  );
}
